module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Bank-73e09ddf48ff1a5c8e2537657d91c1e9.png";